import type { EthCallMethodsEnum } from "sagas/ActionExecution/EthereumActionSaga";
import { promisify } from "./utils/Promisify";

export enum NavigationTargetType {
  SAME_WINDOW = "SAME_WINDOW",
  NEW_WINDOW = "NEW_WINDOW",
}

function ethereumFnDescriptor(
  method: EthCallMethodsEnum,
  data?: Record<string, any>,
) {
  return {
    type: "ETH_CALL" as const,
    payload: { method, data },
  };
}

export type TEthereumArgs = Parameters<typeof ethereumFnDescriptor>;
export type TEthereumDescription = ReturnType<typeof ethereumFnDescriptor>;
export type TEthereumActionType = TEthereumDescription["type"];

async function ethCall(...args: Parameters<typeof ethereumFnDescriptor>) {
  return promisify(ethereumFnDescriptor)(...args);
}

export default ethCall;
